import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  FiUser,
  FiMail,
  FiPhone,
  FiBriefcase,
  FiKey,
  FiShield,
  FiEdit2,
  FiSave,
  FiX,
  FiCopy,
  FiCheck,
  FiBarChart2,
  FiClock,
  FiMessageSquare,
} from "react-icons/fi";

function Profile() {
  const { user, token } = useSelector((state) => state.auth);
  const [editing, setEditing] = useState(false);
  const [copied, setCopied] = useState(false);
  const [activeTab, setActiveTab] = useState("profile");
  const [form, setForm] = useState({
    name: user?.name || "Business Online",
    email: user?.email || "businessonline25@gmail.com",
    phone: user?.phone || "9876543210",
    companyName: user?.companyName || "Business Online Pvt Ltd",
  });
  const [passwords, setPasswords] = useState({
    current: "",
    newPass: "",
    confirm: "",
  });
  const [pwMsg, setPwMsg] = useState("");

  const handleCopy = () => {
    navigator.clipboard.writeText(user?.apiKey || "cbx_demo_key_xxxxx");
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleSave = () => {
    // dispatch updateProfile action here
    setEditing(false);
  };

  const handlePasswordChange = () => {
    if (passwords.newPass !== passwords.confirm) {
      setPwMsg("Passwords do not match!");
      return;
    }
    if (passwords.newPass.length < 6) {
      setPwMsg("Password must be at least 6 characters.");
      return;
    }
    setPwMsg("Password updated successfully!");
    setPasswords({ current: "", newPass: "", confirm: "" });
  };

  const stats = [
    {
      label: "Total Messages Sent",
      value: user?.totalMessagesSent || 0,
      icon: <FiMessageSquare />,
      color: "#7C3AED",
      bg: "#EDE9FE",
    },
    {
      label: "Credits Balance",
      value: `₹${user?.credits || 0}`,
      icon: <FiBarChart2 />,
      color: "#D97706",
      bg: "#FEF3C7",
    },
    {
      label: "Total Spent",
      value: `₹${user?.totalSpent || 0}`,
      icon: <FiBarChart2 />,
      color: "#059669",
      bg: "#D1FAE5",
    },
    {
      label: "Member Since",
      value: user?.createdAt ? new Date(user.createdAt).getFullYear() : "2024",
      icon: <FiClock />,
      color: "#DC2626",
      bg: "#FEE2E2",
    },
  ];

  const tabs = [
    { id: "profile", label: "My Profile" },
    { id: "security", label: "Security" },
    { id: "api", label: "API Access" },
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        .pf * { box-sizing: border-box; margin: 0; padding: 0; font-family: 'Plus Jakarta Sans', sans-serif; }

        .pf {
          background: #F5F6FA;
          min-height: 100vh;
          padding: 28px 30px;
        }

        .pf-title {
          font-size: 22px;
          font-weight: 800;
          color: #1e1b4b;
          margin-bottom: 4px;
        }

        .pf-welcome-bar {
          background: #fff;
          border-radius: 14px;
          padding: 14px 20px;
          font-size: 14px;
          font-weight: 600;
          color: #374151;
          border: 1.5px solid #ede9fe;
          margin-bottom: 22px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .pf-credit-chip {
          background: linear-gradient(135deg, #7C3AED, #6C63FF);
          color: #fff;
          border-radius: 50px;
          padding: 6px 16px;
          font-size: 13px;
          font-weight: 700;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .pf-section-head {
          font-size: 15px;
          font-weight: 700;
          color: #374151;
          margin-bottom: 14px;
          border-left: 3px solid #7C3AED;
          padding-left: 10px;
        }

        /* Stats row */
        .pf-stats {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 14px;
          margin-bottom: 22px;
        }

        @media(max-width:1000px){ .pf-stats{ grid-template-columns:repeat(2,1fr); } }

        .pf-stat-card {
          background: #fff;
          border-radius: 16px;
          padding: 18px 16px 14px;
          border: 1.5px solid #f0effe;
          box-shadow: 0 2px 8px rgba(124,58,237,0.05);
          transition: all 0.2s ease;
        }

        .pf-stat-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 24px rgba(124,58,237,0.1);
          border-color: #c4b5fd;
        }

        .pf-stat-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
        }

        .pf-stat-label {
          font-size: 11.5px;
          font-weight: 700;
          color: #9ca3af;
          text-transform: uppercase;
          letter-spacing: 0.4px;
        }

        .pf-stat-ico {
          width: 30px; height: 30px;
          border-radius: 9px;
          display: flex; align-items: center; justify-content: center;
          font-size: 15px;
        }

        .pf-stat-val {
          font-size: 30px;
          font-weight: 800;
          color: #1e1b4b;
          line-height: 1;
        }

        /* Main layout */
        .pf-main {
          display: grid;
          grid-template-columns: 280px 1fr;
          gap: 16px;
        }

        @media(max-width:900px){ .pf-main{ grid-template-columns:1fr; } }

        /* Avatar card */
        .pf-card {
          background: #fff;
          border-radius: 16px;
          padding: 24px 20px;
          border: 1.5px solid #f0effe;
          box-shadow: 0 2px 8px rgba(124,58,237,0.05);
        }

        .pf-avatar-wrap {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 20px;
        }

        .pf-avatar {
          width: 88px; height: 88px;
          border-radius: 50%;
          background: linear-gradient(135deg, #7C3AED, #6C63FF);
          display: flex; align-items: center; justify-content: center;
          font-size: 36px;
          font-weight: 800;
          color: #fff;
          margin-bottom: 12px;
          box-shadow: 0 4px 18px rgba(124,58,237,0.25);
          position: relative;
        }

        .pf-avatar-badge {
          position: absolute;
          bottom: 2px; right: 2px;
          width: 22px; height: 22px;
          border-radius: 50%;
          background: #16a34a;
          border: 2.5px solid #fff;
        }

        .pf-avatar-name {
          font-size: 17px;
          font-weight: 800;
          color: #1e1b4b;
        }

        .pf-avatar-email {
          font-size: 12.5px;
          color: #9ca3af;
          font-weight: 500;
          margin-top: 2px;
        }

        .pf-role-chip {
          margin-top: 8px;
          background: #EDE9FE;
          color: #7C3AED;
          border-radius: 99px;
          padding: 4px 14px;
          font-size: 12px;
          font-weight: 700;
        }

        .pf-divider {
          border: none;
          border-top: 1.5px solid #f3f4f6;
          margin: 16px 0;
        }

        .pf-info-row {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 8px 0;
          font-size: 13px;
          color: #6b7280;
          font-weight: 500;
          border-bottom: 1px solid #f9fafb;
        }

        .pf-info-row:last-child { border-bottom: none; }

        .pf-info-row svg { color: #7C3AED; flex-shrink: 0; }

        .pf-status-dot {
          width: 8px; height: 8px;
          border-radius: 50%;
          background: #16a34a;
          display: inline-block;
          margin-right: 4px;
        }

        /* Right panel */
        .pf-right {}

        /* Tabs */
        .pf-tabs {
          display: flex;
          gap: 4px;
          background: #fff;
          border-radius: 12px;
          padding: 6px;
          border: 1.5px solid #f0effe;
          margin-bottom: 16px;
          width: fit-content;
        }

        .pf-tab {
          padding: 8px 20px;
          border-radius: 9px;
          font-size: 13px;
          font-weight: 700;
          cursor: pointer;
          border: none;
          background: none;
          color: #9ca3af;
          font-family: 'Plus Jakarta Sans', sans-serif;
          transition: all 0.2s;
        }

        .pf-tab.active {
          background: linear-gradient(135deg, #7C3AED, #6C63FF);
          color: #fff;
          box-shadow: 0 4px 12px rgba(124,58,237,0.25);
        }

        /* Form */
        .pf-form-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
          margin-bottom: 20px;
        }

        @media(max-width:700px){ .pf-form-grid{ grid-template-columns:1fr; } }

        .pf-form-group {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }

        .pf-form-group label {
          font-size: 12px;
          font-weight: 700;
          color: #9ca3af;
          text-transform: uppercase;
          letter-spacing: 0.4px;
        }

        .pf-input-wrap {
          display: flex;
          align-items: center;
          gap: 10px;
          border: 1.5px solid #e5e7eb;
          border-radius: 11px;
          padding: 10px 14px;
          background: #fff;
          transition: border 0.2s;
        }

        .pf-input-wrap:focus-within {
          border-color: #7C3AED;
          box-shadow: 0 0 0 3px rgba(124,58,237,0.08);
        }

        .pf-input-wrap svg { color: #9ca3af; flex-shrink: 0; }

        .pf-input-wrap input {
          border: none;
          outline: none;
          font-size: 13.5px;
          font-weight: 600;
          color: #374151;
          background: transparent;
          width: 100%;
          font-family: 'Plus Jakarta Sans', sans-serif;
        }

        .pf-input-wrap input:disabled {
          color: #9ca3af;
          cursor: not-allowed;
        }

        .pf-btn-primary {
          background: linear-gradient(135deg, #7C3AED, #6C63FF);
          color: #fff;
          border: none;
          border-radius: 11px;
          padding: 10px 24px;
          font-size: 13px;
          font-weight: 700;
          cursor: pointer;
          font-family: 'Plus Jakarta Sans', sans-serif;
          display: flex;
          align-items: center;
          gap: 7px;
          transition: all 0.2s;
          box-shadow: 0 4px 12px rgba(124,58,237,0.25);
        }

        .pf-btn-primary:hover { opacity: 0.9; transform: translateY(-1px); }

        .pf-btn-outline {
          background: #fff;
          color: #7C3AED;
          border: 1.5px solid #7C3AED;
          border-radius: 11px;
          padding: 10px 24px;
          font-size: 13px;
          font-weight: 700;
          cursor: pointer;
          font-family: 'Plus Jakarta Sans', sans-serif;
          display: flex;
          align-items: center;
          gap: 7px;
          transition: all 0.2s;
        }

        .pf-btn-outline:hover { background: #faf5ff; }

        .pf-btn-row {
          display: flex;
          gap: 10px;
          align-items: center;
        }

        /* API key */
        .pf-api-box {
          background: #F5F6FA;
          border-radius: 12px;
          padding: 14px 16px;
          border: 1.5px dashed #c4b5fd;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          margin-bottom: 14px;
        }

        .pf-api-key {
          font-size: 13px;
          font-weight: 700;
          color: #7C3AED;
          font-family: monospace;
          word-break: break-all;
        }

        .pf-copy-btn {
          background: #EDE9FE;
          border: none;
          border-radius: 9px;
          padding: 8px 14px;
          cursor: pointer;
          font-size: 12px;
          font-weight: 700;
          color: #7C3AED;
          font-family: 'Plus Jakarta Sans', sans-serif;
          display: flex;
          align-items: center;
          gap: 6px;
          flex-shrink: 0;
          transition: all 0.2s;
        }

        .pf-copy-btn:hover { background: #ddd6fe; }

        .pf-warn {
          background: #FEF3C7;
          border-radius: 10px;
          padding: 10px 14px;
          font-size: 12.5px;
          color: #92400e;
          font-weight: 600;
          border: 1.5px solid #fde68a;
          margin-bottom: 14px;
        }

        .pf-card-title {
          font-size: 14px;
          font-weight: 700;
          color: #374151;
          margin-bottom: 18px;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .pf-card-title svg { color: #7C3AED; }

        .pf-msg {
          font-size: 12.5px;
          font-weight: 600;
          margin-top: 10px;
          padding: 8px 14px;
          border-radius: 9px;
        }

        .pf-msg.success { background: #D1FAE5; color: #065f46; }
        .pf-msg.error { background: #FEE2E2; color: #991b1b; }

        .pf-verified-chip {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          background: #D1FAE5;
          color: #059669;
          border-radius: 99px;
          padding: 3px 12px;
          font-size: 11.5px;
          font-weight: 700;
        }
      `}</style>

      <div className="pf">
        {/* Title */}
        <div className="pf-title">My Profile</div>

        {/* Welcome bar */}
        <div className="pf-welcome-bar">
          <span>Welcome : {user?.email || "businessonline25@gmail.com"}</span>
          <div className="pf-credit-chip">💳 INR : {user?.credits || "0"}</div>
        </div>

        {/* Stats */}
        <div className="pf-section-head">Account Overview</div>
        <div className="pf-stats">
          {stats.map((s, i) => (
            <div className="pf-stat-card" key={i}>
              <div className="pf-stat-top">
                <span className="pf-stat-label">{s.label}</span>
                <div
                  className="pf-stat-ico"
                  style={{ background: s.bg, color: s.color }}
                >
                  {s.icon}
                </div>
              </div>
              <div className="pf-stat-val">{s.value}</div>
            </div>
          ))}
        </div>

        {/* Main */}
        <div className="pf-main">
          {/* Left: Avatar Card */}
          <div>
            <div className="pf-card">
              <div className="pf-avatar-wrap">
                <div className="pf-avatar">
                  {(user?.name || "B")[0].toUpperCase()}
                  <div className="pf-avatar-badge" />
                </div>
                <div className="pf-avatar-name">
                  {user?.name || "Business Online"}
                </div>
                <div className="pf-avatar-email">
                  {user?.email || "businessonline25@gmail.com"}
                </div>
                <div className="pf-role-chip">
                  👑 {user?.role === "admin" ? "Admin" : "User"}
                </div>
              </div>

              <hr className="pf-divider" />

              <div className="pf-info-row">
                <FiPhone size={14} />
                {user?.phone || "Not set"}
              </div>
              <div className="pf-info-row">
                <FiBriefcase size={14} />
                {user?.companyName || "Not set"}
              </div>
              <div className="pf-info-row">
                <FiShield size={14} />
                <span>
                  <span className="pf-status-dot" />
                  {user?.status === "active"
                    ? "Active Account"
                    : user?.status || "Active"}
                </span>
              </div>
              <div className="pf-info-row">
                <FiCheck size={14} />
                {user?.isVerified ? (
                  <span className="pf-verified-chip">✅ Verified</span>
                ) : (
                  <span style={{ color: "#DC2626" }}>Not Verified</span>
                )}
              </div>
            </div>
          </div>

          {/* Right */}
          <div className="pf-right">
            {/* Tabs */}
            <div className="pf-tabs">
              {tabs.map((t) => (
                <button
                  key={t.id}
                  className={`pf-tab ${activeTab === t.id ? "active" : ""}`}
                  onClick={() => setActiveTab(t.id)}
                >
                  {t.label}
                </button>
              ))}
            </div>

            {/* Profile Tab */}
            {activeTab === "profile" && (
              <div className="pf-card">
                <div className="pf-card-title">
                  <FiUser />
                  Personal Information
                  {!editing && (
                    <button
                      className="pf-btn-outline"
                      style={{
                        marginLeft: "auto",
                        padding: "6px 16px",
                        fontSize: "12px",
                      }}
                      onClick={() => setEditing(true)}
                    >
                      <FiEdit2 size={13} /> Edit
                    </button>
                  )}
                </div>

                <div className="pf-form-grid">
                  <div className="pf-form-group">
                    <label>Full Name</label>
                    <div className="pf-input-wrap">
                      <FiUser size={14} />
                      <input
                        disabled={!editing}
                        value={form.name}
                        onChange={(e) =>
                          setForm({ ...form, name: e.target.value })
                        }
                        placeholder="Your name"
                      />
                    </div>
                  </div>

                  <div className="pf-form-group">
                    <label>Email Address</label>
                    <div className="pf-input-wrap">
                      <FiMail size={14} />
                      <input disabled value={form.email} placeholder="Email" />
                    </div>
                  </div>

                  <div className="pf-form-group">
                    <label>Phone Number</label>
                    <div className="pf-input-wrap">
                      <FiPhone size={14} />
                      <input
                        disabled={!editing}
                        value={form.phone}
                        onChange={(e) =>
                          setForm({ ...form, phone: e.target.value })
                        }
                        placeholder="Phone"
                      />
                    </div>
                  </div>

                  <div className="pf-form-group">
                    <label>Company Name</label>
                    <div className="pf-input-wrap">
                      <FiBriefcase size={14} />
                      <input
                        disabled={!editing}
                        value={form.companyName}
                        onChange={(e) =>
                          setForm({ ...form, companyName: e.target.value })
                        }
                        placeholder="Company"
                      />
                    </div>
                  </div>
                </div>

                {editing && (
                  <div className="pf-btn-row">
                    <button className="pf-btn-primary" onClick={handleSave}>
                      <FiSave size={14} /> Save Changes
                    </button>
                    <button
                      className="pf-btn-outline"
                      onClick={() => setEditing(false)}
                    >
                      <FiX size={14} /> Cancel
                    </button>
                  </div>
                )}
              </div>
            )}

            {/* Security Tab */}
            {activeTab === "security" && (
              <div className="pf-card">
                <div className="pf-card-title">
                  <FiShield />
                  Change Password
                </div>

                <div className="pf-form-grid">
                  <div className="pf-form-group">
                    <label>Current Password</label>
                    <div className="pf-input-wrap">
                      <FiKey size={14} />
                      <input
                        type="password"
                        value={passwords.current}
                        onChange={(e) =>
                          setPasswords({
                            ...passwords,
                            current: e.target.value,
                          })
                        }
                        placeholder="••••••••"
                      />
                    </div>
                  </div>

                  <div className="pf-form-group">
                    <label>New Password</label>
                    <div className="pf-input-wrap">
                      <FiKey size={14} />
                      <input
                        type="password"
                        value={passwords.newPass}
                        onChange={(e) =>
                          setPasswords({
                            ...passwords,
                            newPass: e.target.value,
                          })
                        }
                        placeholder="••••••••"
                      />
                    </div>
                  </div>

                  <div className="pf-form-group" style={{ gridColumn: "1/-1" }}>
                    <label>Confirm New Password</label>
                    <div className="pf-input-wrap">
                      <FiKey size={14} />
                      <input
                        type="password"
                        value={passwords.confirm}
                        onChange={(e) =>
                          setPasswords({
                            ...passwords,
                            confirm: e.target.value,
                          })
                        }
                        placeholder="••••••••"
                      />
                    </div>
                  </div>
                </div>

                <button
                  className="pf-btn-primary"
                  onClick={handlePasswordChange}
                >
                  <FiShield size={14} /> Update Password
                </button>

                {pwMsg && (
                  <div
                    className={`pf-msg ${pwMsg.includes("success") ? "success" : "error"}`}
                  >
                    {pwMsg}
                  </div>
                )}
              </div>
            )}

            {/* API Tab */}
            {activeTab === "api" && (
              <div className="pf-card">
                <div className="pf-card-title">
                  <FiKey />
                  API Access Key
                </div>

                <div className="pf-warn">
                  ⚠️ Keep your API key secret. Do not share it publicly or
                  commit it to version control.
                </div>

                <div className="pf-api-box">
                  <span className="pf-api-key">
                    {user?.apiKey
                      ? user.apiKey.slice(0, 20) + "••••••••••••••••••••"
                      : "cbx_•••••••••••••••••••••••••••••"}
                  </span>
                  <button className="pf-copy-btn" onClick={handleCopy}>
                    {copied ? <FiCheck size={13} /> : <FiCopy size={13} />}
                    {copied ? "Copied!" : "Copy"}
                  </button>
                </div>

                <div style={{ marginBottom: 18 }}>
                  <p
                    style={{
                      fontSize: "13px",
                      color: "#6b7280",
                      fontWeight: 500,
                      lineHeight: 1.6,
                    }}
                  >
                    Use this API key to authenticate your requests. Include it
                    in the{" "}
                    <code
                      style={{
                        background: "#EDE9FE",
                        color: "#7C3AED",
                        padding: "2px 6px",
                        borderRadius: 5,
                        fontWeight: 700,
                      }}
                    >
                      Authorization
                    </code>{" "}
                    header of your HTTP requests.
                  </p>
                </div>

                <button className="pf-btn-primary">
                  <FiKey size={14} /> Regenerate API Key
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Profile;
